import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";

import { useUser } from "../../../util/user";
import GYAxios from "../../../util/GYAxios";

import ReceiptTemplate from "../InvoiceComp/ReceiptTemplate";
import ReceiptTemplate_MSA from "../InvoiceComp/ReceiptTemplate_MSA";
import { localTimeToPickerTime, pickerTimeTolocalTime } from "../../../util/momentTimezone";
import { buildInvoiceReceiptNumber } from "../../../util/invoice";

const ReceiptForm = (props) => {
	const getInitStartDate = (paymentDate) =>
		paymentDate != null ? moment(paymentDate) : moment();
	const initStartDate = getInitStartDate(
		props.selectedReceipt.receipt.paymentDate
	);
	const isMSA = props.selectedReceipt.invoice.operation_status === 2
	const [selectedDate, setSelectedDate] = useState(initStartDate);
	const [minDate, setMinDate] = useState(moment().subtract(1, "month"));
	const [selectedReceipt, setSelectedReceipt] = useState(props.selectedReceipt);
	const [lastUpdate, setLastUpdate] = useState(props.selectedReceipt.receipt);
	const [isMSAReceipt, setIsMSAReceipt] = useState(isMSA)
	const user = useUser();
	const username = user.name;
	const userID = user.sub;

	const resetForm = props.resetForm;
	const isEdit = props.isEdit;
	const lastUpdateStyle = {
		textAlign: "right",
		paddingRight: "15px",
	};

	/**
	 * Handle submit form
	 * @param {Unused data} data
	 */
	const handleSubmit = (e) => {
		const currentReceipt = selectedReceipt.receipt;
		const now = moment().format("YYYY-MM-DD HH:mm:ss");
		const paymentDate = moment(currentReceipt.paymentDate).format("DD/MM/YYYY");

		const tempReceipt = { ...currentReceipt, issuedAt: now };

		const confirmSubmit = window.confirm(
			`Confirm payment date: ${paymentDate}?`
		);

		if (confirmSubmit) submitIssue(tempReceipt);

		e.preventDefault();
	};

	/**
	 * Submit issue form
	 * @param {obj} param
	 */
	const submitIssue = (param) => {
		const notify = props.notify;
		const id = param.id;
		const receiptNo = param.receiptNo;
		const paymentDate = param.paymentDate;
		const issuedAt = param.issuedAt;
		const issuedBy = param.issuedBy;
		const issuedByID = param.issuedByID;

		const patchParam = {
			receiptNo,
			paymentDate,
			issuedAt,
			issuedBy,
			issuedByID,
		};

		GYAxios.patch(`/receipts/${id}`, patchParam).then((res) => {
			const response = res.data;

			// Error notification
			if (response.error != null)
				notify({ type: "e", msg: "Receipt issue failed!" });
			// No rows affected notification
			else if (response.changedRows <= 0)
				notify({ type: "w", msg: "No changes to receipt" });
			// Update successful notification
			else notify({ type: "s", msg: "Receipt issued successfully" });

			resetForm();
		});
	};

	useEffect(() => {
		const invoiceObj =
			props.selectedReceipt != null ? props.selectedReceipt.invoice : null;
		const receiptObj =
			props.selectedReceipt != null ? props.selectedReceipt.receipt : null;

		if (invoiceObj != null) {
			const refInv = Array.isArray(invoiceObj) ? invoiceObj[0] : invoiceObj;

			const tempMinDate = moment(refInv.dateData)
				.add(1, "month")
				.startOf("month");

			setMinDate(tempMinDate);
		}

		let lastUpdateObj = null;

		if (receiptObj.issuedBy != null) {
			lastUpdateObj = {
				issuedBy: receiptObj.issuedBy,
				issuedAt: moment(receiptObj.issuedAt).format("DD/MM/YYYY HH:mm:ss"),
			};
		}

		setLastUpdate(lastUpdateObj);
	}, [props.selectedReceipt]);

	useEffect(() => {
		const invoiceObj = selectedReceipt.invoice;
		let new_bill = null;

		const getBillDetailsChanged = async (uri) => {
			const response = await GYAxios.get(uri).catch((err) => {
				console.log(err);
			});
			const data = response?.data;
			return data;
		}

		if (invoiceObj != null) {
			let isBillChanged = false;
			let refInv = null;
			let table_bill = null;

			if (Array.isArray(invoiceObj)) {
				refInv = invoiceObj[0].additional_info;
				table_bill = invoiceObj[0].table_name
			} else {
				refInv = invoiceObj.additional_info;
				table_bill = invoiceObj.table_name
			}

			if (refInv != null && refInv != "") {
				const obj_info = JSON.parse(refInv);
				if (obj_info.invoice != null) {
					isBillChanged = obj_info.invoice.billing_changed;
				}
			}

			if (isBillChanged) {
				const day_bill = selectedDate.format("YYYYMMDD");
				const uriBill = `/receipts/billing_details/${table_bill}/${day_bill}`
				new_bill = getBillDetailsChanged(uriBill);
			}
		}
		
		if (isEdit) {
			const receiptObj = {
				...selectedReceipt.receipt,
				paymentDate: selectedDate.format("YYYY-MM-DD"),
				issuedByID: userID,
				issuedBy: username,
			};

			const tempReceipts = { ...selectedReceipt, receipt: receiptObj };

			if (new_bill != null) {
				new_bill.then((res) => {
					if (!Array.isArray(tempReceipts.invoice)) {
						tempReceipts.invoice.billing_address = res[0]?.billing_address;
						tempReceipts.invoice.billing_name = res[0]?.billing_name;
					} else {
						tempReceipts.invoice[0].billing_address = res[0]?.billing_address;
						tempReceipts.invoice[0].billing_name = res[0]?.billing_name;

					}
					setSelectedReceipt(tempReceipts);
				});
			} else {
				setSelectedReceipt(tempReceipts);

			}
		} else {
			let siteCode = "";

			// Makro receipts
			if (Array.isArray(invoiceObj)) {
				const invoiceNo = invoiceObj[0].invoiceNo;
				const invoiceSplit = invoiceNo.split("-");
				siteCode = invoiceSplit[1];
			}
			// Regular receipts
			else siteCode = invoiceObj.site_code;

			const solarEntityId = invoiceObj.entity_id || invoiceObj[0]?.entity_id;
			const refReceiptNo = buildInvoiceReceiptNumber({ type: 'REC', solarEntityId, siteCode, date: selectedDate, isMSA: isMSAReceipt, isReceiptRef: true });;

			// Fetch number of receipt issued
			GYAxios.get(`/receipts/count/${refReceiptNo}`).then((res) => {
				const response = res.data;
				let count = 0;
				let documentNo = "";

				if (!response.error) count = response.count + 1;

				// Format numbers less than 10
				if (count < 10) documentNo = `0${count}`;
				else documentNo = count;

				const generatedRecNo = buildInvoiceReceiptNumber({ type: 'REC', solarEntityId, siteCode, date: selectedDate, docNo: documentNo, isMSA: isMSAReceipt });

				const receiptObj = {
					...selectedReceipt.receipt,
					paymentDate: selectedDate.format("YYYY-MM-DD"),
					receiptNo: generatedRecNo,
					issuedByID: userID,
					issuedBy: username,
				};

				const tempReceipts = { ...selectedReceipt, receipt: receiptObj };

				if (new_bill != null) {
					new_bill.then((res) => {
						if (!Array.isArray(tempReceipts.invoice)) {
							tempReceipts.invoice.billing_address = res[0]?.billing_address;
							tempReceipts.invoice.billing_name = res[0]?.billing_name;
						} else {
							tempReceipts.invoice[0].billing_address = res[0]?.billing_address;
							tempReceipts.invoice[0].billing_name = res[0]?.billing_name;
	
						}
						setSelectedReceipt(tempReceipts);
					});
				} else {
					setSelectedReceipt(tempReceipts);
				}
			});
		}
	}, [selectedDate]);

	return (
		<>
			<Col md="4" id="receipt-form-container">
				{/* Header */}
				<Row id="receipt-form-header">
					<h4>Issue receipt</h4>
				</Row>

				{/* Form section */}
				<Row id="receipt-form-content" onSubmit={handleSubmit}>
					<Form>
						{/* Form inputs */}
						<Form.Group as={Row} controlId="paymentDateInput">
							<Form.Label column md={4}>
								Payment Date:
							</Form.Label>
							<Col md={8} id="receipt-date-form">
								<DatePicker
									id="receipt-date"
									selected={localTimeToPickerTime(selectedDate.toDate())}
									onChange={(date) => {
										const dateObj = moment(pickerTimeTolocalTime(date));
										if (dateObj._isValid) setSelectedDate(dateObj);
									}}
									dateFormat="dd/MM/yyyy"
									minDate={localTimeToPickerTime(minDate.toDate())}
									maxDate={localTimeToPickerTime(moment().toDate())}
								/>
							</Col>
						</Form.Group>

						{/* Show last updated info */}
						{lastUpdate != null && (
							<Form.Group as={Row} style={lastUpdateStyle}>
								Last updated by: <b>{lastUpdate.issuedBy}</b> at{" "}
								<i>{lastUpdate.issuedAt}</i>
							</Form.Group>
						)}

						{/* Form buttons */}
						<Form.Group as={Row} controlId="btn">
							<Col md="6">
								<Button
									className="receipt-form-btn"
									variant="secondary"
									onClick={resetForm}
								>
									Cancel
								</Button>
							</Col>
							<Col md="6">
								<Button
									variant="primary"
									as="input"
									type="submit"
									value="Submit"
									className="receipt-form-btn"
								/>
							</Col>
						</Form.Group>
					</Form>
				</Row>
			</Col>
			<Col md="8">
				{isMSAReceipt ? <ReceiptTemplate_MSA receipt={selectedReceipt} /> : <ReceiptTemplate receipt={selectedReceipt} />}
			</Col>
		</>
	);
};

export default ReceiptForm;
